<template>
  <div class="main-container" v-if="appointments.length > 0 && !loading">
    <div v-if="showTokenRequest">
      <!-- <app-number-keyboard :enterFunction="searchPatientAppointments" :title="getMessage('MSG_INGRESA_NUMERO_DOCUMENTO')"></app-number-keyboard> -->
      <number-keyboard
        :title="getMessage('MSG_INGRESE_TOKEN')"
        @numberInput="handleNumberInput($event)"
        @cancel="onCancelNumberKeyboard"
        :emitValue="true"
      ></number-keyboard>
    </div>
    <div v-else>
      <div class="container header column">
        <h1>{{ getMessage('TTL_PROXIMOS_TURNOS') }}</h1>
        <br />
        <h2 style="font-weight:500px">
          <b style="font-family:'Rubik';font-size:40px;">{{ patient.ficNombreApe }}&nbsp;</b>
          {{ patient.ficTipodoc }}: {{ patient.ficNrodoc }}
        </h2>
      </div>
      <div class="container">
        <!-- Si hay turnos -->
        <div class="appointment-list" v-if="showAppointmentSelector">
          <div
            class="appointment"
            @click="autoRecepcionTurno(appointment)"
            v-for="appointment in appointments"
            :key="appointment.turnoId"
          >
            <div class="appointment-details">
              <div class="appointment-date">
                <div>{{ appointment.turFechaDisplay }}</div>
                <span class="sala">{{ appointment.sala }}</span>
              </div>
              <div class="appointment-date">
                <div>{{ formatServicio(appointment.servicio) }}&nbsp;/&nbsp;{{ formatPrestador(appointment.prestador) }}</div>
              </div>
            </div>
            <div class="btn-select" style="cursor:pointer;">
              <span class="span-ok">{{ getMessage('BTN_OKAY') }}</span>
            </div>
          </div>

          <div class="appointment" v-if="ParametrosGeneralesAmb.imprimeTicketTotem">
            <div class="btn-select" style="margin-left: 0;">
              <router-link :to="{ name: 'printNumber', params: { numRecId: numRecIdConTurnoFromLocalStorage } }" tag="button">
                  {{ getMessage('BTN_IR_RECEPCION_EN_LISTA_TURNOS') }}
              </router-link>
            </div>
            <div class="btn-select">
              <router-link :to="{ name: 'patientSearch' }" tag="button">
                {{ getMessage('BTN_VOLVER_EN_LISTA_TURNOS') }}
              </router-link>
            </div>
          </div>
          <div v-else>
            <div class="btn-select" style="margin: 70px 0 0 0;">
              <router-link :to="{ name: 'patientSearch' }" tag="button">
                {{ getMessage('BTN_VOLVER_EN_LISTA_TURNOS') }}
              </router-link>
            </div>
          </div>
        </div>
        <!-- si no hay turnos -->
        <div class="container" v-else>
          <div class="container">
            <h2>{{ getMessage('MSG_TURNO_NO_ESTA_EN_LISTA') }}</h2>
          </div>
          <div class="container">
            <router-link
              :to="{ name: 'printNumber' }"
              tag="button"
              class="btn-secondary"
              v-if="getParametrosGeneralesAmb.mostrarBtnIrRecepcionAR"
            >{{ getMessage('BTN_IR_RECEPCION') }}</router-link>
            <router-link :to="{ name: 'patientSearch' }" tag="button" class="btn-secondary">{{ getMessage('BTN_VOLVER') }}</router-link>
          </div>
        </div>
        <app-back-home :compFrom="'appointmentSelector'"></app-back-home>
      </div>
      <app-loader></app-loader>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'

import BackHome from '@/components/AutoRecepcion/BackHome'
import Loader from '@/components/AutoRecepcion/Loader'
import NumberKeyboard from '@/components/AutoRecepcion/NumberKeyboard'

export default {
  components: {
    'app-loader': Loader,
    'app-back-home': BackHome,
    'number-keyboard': NumberKeyboard
  },
  data () {
    return {
      numRecIdConTurnoFromLocalStorage: null,
      showAppointmentSelector: false,
      loading: false,
      showTokenRequest: false,
      salasDiferentes: false,
      salaActual: null
    }
  },
  computed: {
    ...mapGetters('InitConfig', [
      'getSalaActual',
      'getParametrosGeneralesAmb'
    ]),
    ...mapState('Patient', ['patient']),
    ...mapState('InitConfig', ['ParametrosGeneralesAmb']),
    ...mapGetters('Appointment', ['appointments']),
    ...mapGetters('GeneralAR', ['getMessage'])
  },
  mounted: function () {
    this.searchPatientAppointments()
    this.numRecIdConTurnoFromLocalStorage = +localStorage.getItem('numRecConTurno')
  },
  methods: {
    ...mapActions('Appointment', [
      'setAppointment',
      'fetchAppointmentsByFicha',
      'autoRecepcionarAppointments',
      'generarNumeroRecepcion',
      'pideToken',
      'validarTurnoSala',
      'obtenerSalaAdministrativa'
    ]),
    formatServicio (servicio) {
      return servicio.length > 35 ? `${servicio.substring(0, 35)}...` : servicio
    },
    formatPrestador (prestador) {
      return prestador.length > 35 ? `${prestador.substring(0, 35)}...` : prestador
    },
    async differentRoomWarning (sala) {
      var vm = this
      try {
        // Obtener el salaId del appointment seleccionado actualmente
        const salaId = this.appointmentSelected?.salaId

        if (salaId) {
          // Llamar al endpoint para obtener la sala administrativa
          const salaAdministrativa = await this.obtenerSalaAdministrativa({
            salaTurnoId: salaId
          })

          // Si existe sala administrativa, usar esa; si no, usar la sala original
          const salaParaMensaje = salaAdministrativa?.Value || sala

          this.$router.push({
            name: 'messageScreen',
            params: {
              message: vm.getMessage('MSG_TURNO_SALA_DIFERENTE', [salaParaMensaje])
            }
          })
        } else {
          // Fallback si no hay salaId disponible
          this.$router.push({
            name: 'messageScreen',
            params: {
              message: vm.getMessage('MSG_TURNO_SALA_DIFERENTE', [sala])
            }
          })
        }
      } catch (error) {
        // En caso de error, usar la sala original
        this.$router.push({
          name: 'messageScreen',
          params: {
            message: vm.getMessage('MSG_TURNO_SALA_DIFERENTE', [sala])
          }
        })
      }
    },
    searchPatientAppointments () {
      var vm = this
      if (this.patient.fichaId > 0) {
        this.loading = true
        this.fetchAppointmentsByFicha(this.patient.fichaId).then(function () {
          vm.loading = false
          vm.checkForAppointments()
        })
      } else {
        vm.checkForAppointments()
      }
    },
    checkForAppointments () {
      var vm = this
      if (vm.appointments.length > 0) {
        vm.showAppointmentSelector = true
      } else {
        vm.$router.push({
          name: 'patientAppointmentNotFound',
          params: {
            message: vm.getMessage('MSG_SIN_TURNOS_DOCUMENTO'),
            data: vm.patient.ficNrodoc
          }
        })
      }
    },
    async autoRecepcionTurno (appointment) {
      this.appointmentSelected = appointment
      // temporal, no se estaba enviando el numRecId cuando tenia turno,
      let numRecId = localStorage.getItem('numRecConTurno')
      if (numRecId === 'null') {
        numRecId = 0 // va a tirar un mensaje de "Numerador no configurado"
      }
      this.numRecIdSelected = numRecId
      this.salaActual = this.getSalaActual()
      const validaARSalaActual = this.getParametrosGeneralesAmb.validaARSalaActual

      this.salasDiferentes = validaARSalaActual && (appointment.salaId !== this.salaActual.salaId)

      let permitirAutoRecepcionSala = true

      if (validaARSalaActual && this.salasDiferentes) {
        const response = await this.validarTurnoSala({
          salaTurnoId: appointment.salaId,
          salaActualId: this.salaActual.salaId
        })

        if (!response.valido) {
          this.differentRoomWarning(appointment.sala)
          permitirAutoRecepcionSala = false
          return
        }
      }

      if (permitirAutoRecepcionSala && !appointment.permiteAutoRecepcion) {
        // turno encontrado sin autorecepcion, imprime numero para recepcion
        // salvo caso de no imprime ticket (Daspu), muestro msj pasar por recepcion
        if (!this.ParametrosGeneralesAmb.imprimeTicketTotem) {
          // TODO msj pasar por recepcion, script base datos
          this.showAppointmentSelector = false
          this.$router.push({
            name: 'messageScreen',
            params: {
              message: this.getMessage('MSG_FALLO_IR_RECEPCION')
            }
          })
          return
        }
        this.generarNumeroRecepcion({
          accionId: localStorage.getItem('accionId'),
          turnoId: appointment.turnoId,
          numRecId: numRecId,
          motivo: 1002 // Con turno sin autorrecepción
        }).then(response => {
          const res = response.data
          this.$router.push({
            name: 'printNumber',
            params: {
              number: res.numeroDisplay,
              date: res.fechaHora,
              header: res.header,
              footer: res.footer,
              salaAdministrativa: res.sala,
              mostrarSalaDiferente: this.salasDiferentes,
              salaTurno: appointment.sala
            }
          })
        }).catch(error => {
          this.$router.push({
            name: 'messageScreen',
            params: {
              message: `Error: ${error.error[0]}`
            }
          })
        })
      } else {
        // intentar autorecepcionar
        // buscar si pide TOKEN la OS
        const pideToken = await this.pideToken({ osId: appointment.osId })
        if (pideToken) {
          this.showTokenRequest = true
          return
        }
        this.autorecepcionarMethod()
      }
    },
    autorecepcionarMethod (token = null) {
      this.showTokenRequest = false
      const appointment = this.appointmentSelected
      const numRecId = this.numRecIdSelected

      this.autoRecepcionarAppointments({
        turnoId: appointment.turnoId,
        fichaId: this.patient.fichaId,
        numRecId: numRecId,
        accionId: localStorage.getItem('accionId'),
        token: token
      }).then(response => {
        if (response.data.exito) {
          if (!this.ParametrosGeneralesAmb.imprimeTicketTotem) {
            this.showAppointmentSelector = false
            this.$router.push({
              name: 'messageScreen',
              params: {
                message: this.getMessage('MSG_SERAS_LLAMADO_POR_NOMBRE', [appointment.sala]),
                showReady: true
              }
            })
            return
          }
          if (response.data.imprimirAtencion) {
            this.$router.push({
              name: 'printAttention',
              params: {
                meId: response.data.comprobanteAtencion.meId,
                date: response.data.comprobanteAtencion.fechaHora,
                header: response.data.comprobanteAtencion.header,
                footer: response.data.comprobanteAtencion.footer,
                mustPay: response.data.pagarCoseguro,
                consultorioSala: response.data.comprobanteAtencion.consultorio,
                mostrarSalaDiferente: this.salasDiferentes,
                salaTurno: appointment.sala
              }
            })
          } else if (response.data.pagarCoseguro) {
            this.$router.push({
              name: 'messageScreen',
              params: {
                message: this.salasDiferentes
                  ? this.getMessage('MSG_TURNO_SALA_DIFERENTE', [this.salaActual.salaNombre]) + '. ' + this.getMessage('MSG_COSEGURO_PENDIENTE')
                  : this.getMessage('MSG_COSEGURO_PENDIENTE'),
                showReady: true
              }
            })
          } else {
            this.$router.push({
              name: 'messageScreen',
              params: {
                message: this.salasDiferentes
                  ? this.getMessage('MSG_TURNO_SALA_DIFERENTE', [this.salaActual.salaNombre])
                  : this.getMessage('MSG_SERAS_LLAMADO_POR_NOMBRE', [appointment.sala]),
                showReady: true
              }
            })
          }
        } else {
          // falla la autorecepcion
          if (!this.ParametrosGeneralesAmb.imprimeTicketTotem) {
            this.showAppointmentSelector = false
            this.$router.push({
              name: 'messageScreen',
              params: {
                message: this.salasDiferentes
                  ? this.getMessage('MSG_TURNO_SALA_DIFERENTE', [this.salaActual.salaNombre]) + '. ' + this.getMessage('MSG_FALLO_IR_RECEPCION')
                  : this.getMessage('MSG_FALLO_IR_RECEPCION')
              }
            })
            return
          }
          this.$router.push({
            name: 'printNumber',
            params: {
              number: response.data.numeroRecepcion.numeroDisplay,
              date: response.data.numeroRecepcion.fechaHora,
              header: response.data.numeroRecepcion.header,
              footer: response.data.numeroRecepcion.footer,
              salaAdministrativa: response.data.numeroRecepcion.sala,
              mostrarSalaDiferente: this.salasDiferentes,
              salaTurno: appointment.sala
            }
          })
        }
        this.showAppointmentSelector = false
      }).catch(error => {
        this.$router.push({
          name: 'messageScreen',
          params: {
            message: `Error: ${error.error[0]}`
          }
        })
      })
    },
    handleNumberInput (token) {
      this.autorecepcionarMethod(token)
    },
    onCancelNumberKeyboard () {
      this.showTokenRequest = false
      this.showAppointmentSelector = true
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>
